var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eval-preview" },
    [
      _vm.showHeader
        ? _c(
            "a-page-header",
            { staticClass: "page-header", on: { back: _vm.back } },
            [
              _c(
                "div",
                {
                  attrs: { slot: "title" },
                  on: { click: _vm.back },
                  slot: "title",
                },
                [
                  _vm._v("\n      返回\n      "),
                  _c("span", { staticStyle: { color: "#297ede" } }, [
                    _vm._v("心理测评"),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.previewEvalData.name)),
          ]),
          _c("div", { staticClass: "remark-area" }, [
            _c("div", [_vm._v("简介：")]),
            _c("div", { staticClass: "remark" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.previewEvalData.remark) + "\n      "
              ),
            ]),
          ]),
          _c("div", { staticClass: "topic-desc" }, [_vm._v("测评内容")]),
          _vm._l(_vm.dataSource, function (item, index) {
            return _c("div", { key: index }, [
              _c(
                "div",
                {
                  ref: "topicRef",
                  refInFor: true,
                  class: {
                    topic: true,
                    "topic-active": _vm.remindStatus && !_vm.selectMode[index],
                  },
                },
                [
                  _vm.remindStatus && !_vm.selectMode[index]
                    ? _c("span", [_vm._v("（未填）")])
                    : _vm._e(),
                  _c("span", [_vm._v(_vm._s(item.name))]),
                ]
              ),
              _c(
                "div",
                { staticClass: "select-area" },
                _vm._l(item.topicArr, function (optItem, optIndex) {
                  return _c(
                    "a-radio-group",
                    {
                      key: optIndex,
                      attrs: { disabled: _vm.radioDisabled },
                      on: { change: _vm.changeRadioGroup },
                      model: {
                        value: _vm.selectMode[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.selectMode, index, $$v)
                        },
                        expression: "selectMode[index]",
                      },
                    },
                    [
                      _c(
                        "a-radio",
                        {
                          attrs: {
                            value: `${item.id},${optItem.id},${optItem.score}`,
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { color: "rgba(0, 0, 0, 0.65)" } },
                            [_vm._v(_vm._s(optItem.name))]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }